export const texts = {
  title: {
    de: 'Passwort vergessen',
    en: 'Forgot password'
  },
  emailLabel: {
    de: 'E-Mail',
    en: 'Email'
  },
  emailPlaceholder: {
    de: 'E-Mail',
    en: 'Email'
  },
  resetError: {
    de: 'Das Passwort konnte nicht zurückgesetzt werden.',
    en: 'The password could not be reset.'
  },
  resetSuccess: {
    de: 'Das Passwort wurde Ihnen zugesendet.',
    en: 'Your password has been sent to you.'
  },
  backToLogin: {
    de: 'Zurück zur Anmeldung',
    en: 'Back to sign in'
  },
  submit: {
    de: 'Passwort zurücksetzen',
    en: 'Reset password'
  },
  hasAccount: {
    de: 'Sie haben bereits einen Account?',
    en: 'Already have an account?'
  },
  signIn: {
    de: 'Anmelden',
    en: 'Sign in'
  }
};
